import React, { useState, useEffect } from "react";
import "./Header.css";
import Logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
import { Link } from "react-scroll";

const Header = ({ isHome }) => {
	const mobile = window.innerWidth <= 768;
	const [menuOpened, setMenuOpened] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<header className={`header ${scrolled ? "scrolled" : ""}`}>
			<a href="/" className="logo-container">
				<img src={Logo} alt="logo" className="logo" />
			</a>



			{menuOpened === false && mobile === true ? (
				<div className="mobile-menu-btn" onClick={() => setMenuOpened(true)}>
					<img src={Bars} alt="menu" />
				</div>
			) : (
				<nav className={`header-nav ${menuOpened ? "open" : ""}`}>
					{mobile && (
						<div className="close-menu" onClick={() => setMenuOpened(false)}>
							&times;
						</div>
					)}
					<ul className="header-menu">
						<li>
							{isHome ? (
								<Link onClick={() => setMenuOpened(false)} activeClass="active" to="hero" spy={true} smooth={true} duration={700}>Home</Link>
							) : (
								<a href="/#hero" onClick={() => setMenuOpened(false)}>Home</a>
							)}
						</li>
						<li>
							{isHome ? (
								<Link onClick={() => setMenuOpened(false)} activeClass="active" to="programs" spy={true} smooth={true} duration={700}>Programs</Link>
							) : (
								<a href="/#programs" onClick={() => setMenuOpened(false)}>Programs</a>
							)}
						</li>
						<li>
							{isHome ? (
								<Link onClick={() => setMenuOpened(false)} activeClass="active" to="reasons" spy={true} smooth={true} duration={700}>Why Us</Link>
							) : (
								<a href="/#reasons" onClick={() => setMenuOpened(false)}>Why Us</a>
							)}
						</li>
						<li>
							{isHome ? (
								<Link onClick={() => setMenuOpened(false)} activeClass="active" to="plans" spy={true} smooth={true} duration={700}>Plans</Link>
							) : (
								<a href="/#plans" onClick={() => setMenuOpened(false)}>Plans</a>
							)}
						</li>
					</ul>
				</nav>
			)}
		</header>
	);
};

export default Header;
